<template>
  <CardModule title="Período de cancelamento">
    <v-radio-group
      v-model="
        $produtos_gerenciar.cadastro.dados_cadastrais.controla_cancelamento
      "
    >
      <v-row>
        <v-col cols="12" class="mb-4">
          <v-radio
            label="Padrão - 7 dias após a compra e até 48h antes do evento"
            class="rounded-lg pa-2"
            style="border: 1px solid rgb(0 0 0 / 42%)"
            active-class="active-class"
            :value="1"
          ></v-radio>
        </v-col>
        <v-col cols="12">
          <v-radio
            label="Personalizado"
            :value="2"
            class="rounded-lg pa-2"
            style="border: 1px solid rgb(0 0 0 / 42%)"
            active-class="active-class"
          ></v-radio>
        </v-col>
      </v-row>
      <v-row v-if="hasCustom" class="mt-4">
        <v-col cols="5">
          <BaseTextField
            v-model="
              $produtos_gerenciar.cadastro.dados_cadastrais
                .dias_canc_apos_compra
            "
            placeholder="0"
            hide-details
            type="number"
          />
        </v-col>
        <v-col class="align-center d-flex">
          <span>dias após a <br />compra</span>
        </v-col>
        <!-- <v-col cols="2" class="align-center d-flex">
          <span>até</span>
        </v-col> -->
        <v-col cols="5">
          <BaseTextField
            v-model="
              $produtos_gerenciar.cadastro.dados_cadastrais
                .horas_canc_antes_evento
            "
            placeholder="0"
            hide-details
            type="number"
            :options="options5"
          />
        </v-col>
        <v-col class="align-center d-flex">
          <span>horas antes do evento</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="mt-4">
          <v-radio
            label="Desabilitado - Consumidor pode cancelar a qualquer momento"
            :value="0"
            class="rounded-lg pa-2"
            style="border: 1px solid rgb(0 0 0 / 42%)"
            active-class="active-class"
          ></v-radio>
        </v-col>
      </v-row>
    </v-radio-group>
  </CardModule>
</template>

<script>
import mixins from "@/mixins";
import CardModule from "@/components/cards/CardModule.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";

export default {
  name: "OptionCancellation",
  mixins: [mixins],
  components: {
    CardModule,
    BaseTextField,
  },
  data() {
    return {
      options5: {
        locale: "pt-BR",
        suffix: "UTC-3",
      },
    };
  },
  watch: {
    // PADRÃO 7 DIAS E 48H
    "$produtos_gerenciar.cadastro.dados_cadastrais.controla_cancelamento"(e) {
      if (e == 0) {
        this.$produtos_gerenciar.cadastro.dados_cadastrais.dias_canc_apos_compra = 7;

        this.$produtos_gerenciar.cadastro.dados_cadastrais.horas_canc_antes_evento = 48;
      }
      if (e == 1) {
        this.$produtos_gerenciar.cadastro.dados_cadastrais.dias_canc_apos_compra = 7;

        this.$produtos_gerenciar.cadastro.dados_cadastrais.horas_canc_antes_evento = 48;
      }
    },
  },
  computed: {
    hasCustom() {
      return (
        this.$produtos_gerenciar.cadastro.dados_cadastrais
          .controla_cancelamento === 2
      );
    },
  },
  created() {
    if (
      this.$produtos_gerenciar.cadastro.dados_cadastrais.dias_canc_apos_compra >
      7
    ) {
      this.$produtos_gerenciar.cadastro.dados_cadastrais.controla_cancelamento = 2;
    }
  },
};
</script>

<style>
.active-class {
  background-color: #e6f7ff !important;
  border-color: #91d5ff !important;
  color: #1890ff !important;
}
</style>
